<template>
	<div class="sale">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>售后服务</span>
			<div></div>
		</div>
		<!-- 处理详情 -->
		<van-tabs v-model="active" swipeable>
			<van-search shape="round" placeholder="商品名称/商品编号/订单号" />
			<van-tab :title="item.name" v-for="item in list" :name="item.id"></van-tab>
			<span class="status">没有更多了~</span>
			<!-- <van-panel>
					<div slot="header" class="van-panel__header">
						<span>订单编号: 000000000</span>
					</div>
					<div class="content">
						<div class="list">
							<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../assets/bantai(2).png">
								<div slot="price" class="sale_price">
									<div>
										<span>兆生家具</span>
										<span>租五年</span>
									</div>
									<van-button round size="mini" color="#F1452F" plain to="/apply">申请售后</van-button>
								</div>
							</van-card>
						</div>
						<div class="list">
							<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../assets/bantai(2).png">
								<div slot="price" class="sale_price">
									<div>
										<span>兆生家具</span>
										<span>租五年</span>
									</div>
									<van-button round size="mini" color="#F1452F" plain to="/apply">申请售后</van-button>
								</div>
							</van-card>
						</div>
					</div>
				</van-panel> -->
			<!-- 				<van-panel>
					<div slot="header" class="van-panel__header">
						<span>订单编号: 000000000</span>
					</div>
					<div class="content">
						<div class="list">
							<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../assets/bantai(2).png">
								<div slot="price" class="sale_price">
									<div>
										<span>兆生家具</span>
										<span>租五年</span>
									</div>
									<van-button round size="mini" color="#F1452F" plain to="/apply">申请售后</van-button>
								</div>
							</van-card>
						</div>
					</div>
				</van-panel> -->
			<van-panel>
				<div slot="header" class="van-panel__header">
					<span>订单编号: 000000000</span>
					<div>
						<img src="../../assets/repair.png" alt="">
						<span class="color_a1">维修</span>
					</div>
				</div>
				<div class="content record_content">
					<div class="list">
						<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../assets/bantai(2).png">
							<div slot="footer">
								<div class="doing_footer">已完成,感谢您对俱百家的支持</div>
								<div class="doing_btn">
									<van-button round size="mini" color="#F1452F" plain to="/apply">申请售后</van-button>
								</div>
							</div>
						</van-card>
					</div>
				</div>
			</van-panel>
			<!-- 				<van-panel>
					<div slot="header" class="van-panel__header">
						<span>订单编号: 000000000</span>
						<div>
							<img src="../../assets/repair.png" alt="">
							<span class="color_a1">维修</span>
						</div>
					</div>
					<div class="content record_content">
						<div class="list">
							<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../assets/bantai(2).png">
								<div slot="footer" class="record_footer">
									已完成,感谢您对俱百家的支持
								</div>
							</van-card>
						</div>
					</div>
				</van-panel> -->
			<van-panel>
				<div slot="header" class="van-panel__header">
					<span>订单编号: 000000000</span>
					<div>
						<img src="../../assets/huan.png" alt="">
						<span class="color_a1">换货</span>
					</div>
				</div>
				<div class="content record_content">
					<div class="list">
						<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb="../../../assets/bantai(2).png">
							<div slot="footer" class="record_footer">
								已完成,感谢您对俱百家的支持
							</div>
						</van-card>
					</div>
				</div>
			</van-panel>
			<!-- 				<van-panel>
					<div slot="header" class="van-panel__header">
						<span>订单编号: 000000000</span>
						<div>
							<img src="../../assets/huan.png" alt="">
							<span class="color_a1">换货</span>
						</div>
					</div>
					<div class="content record_content">
						<div class="list">
							<van-card desc="2.8米X3.8米X1.5米  胡桃木色 拷贝" title="格诺瓦  维纳  B款总裁台" thumb='../../assets/bantai(2).png'>
								<div slot="footer" class="record_footer">
									服务已取消,如有需要可以在售后申请页重新提交售后服务单。
								</div>
							</van-card>
						</div>
					</div>
				</van-panel> -->
		</van-tabs>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				list: [{
					name: '申请售后',
					id: 0
				}, {
					name: '处理中',
					id: 1
				}, {
					name: '申请记录',
					id: 2
				}]
			}
		}
	}
</script>

<style scoped>
	@import 'sale.css'
</style>



// WEBPACK FOOTER //
// src/components/min/sale.vue